import React from 'react';
import { Div } from '@pezeshk-book/ui-kit';

interface LabsItemSchemaProps {
  route?: string
  image?: string
  author?: string
  location?: string
}

const LabsItemSchema = ({ route, image, author, location }: LabsItemSchemaProps) => {
  return (
    <Div className={'hidden'}>
      <meta itemProp="serviceType" content="Laboratory"/>
      <meta itemProp="mainEntityOfPage" content={process.env.APP_SITE_URL_WITH_HTTP}/>
      <span itemProp="provider" itemScope itemType="https://schema.org/Organization">
        <meta itemProp="name" content="پزشک بوک"/>
        <span itemProp="logo" itemScope itemType="https://schema.org/ImageObject">
          <meta itemProp="url" content={`${process.env.APP_SITE_URL_WITH_HTTP}/brand-icons/icon-72x72.png`}/>
        </span>
        <meta itemProp="url" content={process.env.APP_SITE_URL_WITH_HTTP}/>
      </span>
      {image ? (
        <span itemProp="image" itemScope itemType="https://schema.org/ImageObject">
          <meta itemProp="url" content={image.indexOf('https://') !== -1 ? image : `${process.env.APP_SITE_URL_WITH_HTTP}${image}`}/>
          <meta itemProp="height" content="480"/>
          <meta itemProp="width" content="720"/>
        </span>
      ) : null}
      {location ? (
        <span itemProp="areaServed" itemScope itemType="https://schema.org/State">
          <meta itemProp="name" content={location}/>
        </span>
      ) : null}
      {route ? (
        <meta itemProp="url" content={`${process.env.APP_SITE_URL_WITH_HTTP}${route}`}/>
      ) : null}
    </Div>
  );
};

export default LabsItemSchema;
